@if (notice(); as notice) {
  <div class="maintenance-period-card">
    <h4>
      {{ 'MAINTENANCE_PERIOD_MODAL_TITLE' | translate }}
    </h4>
    <p>{{ 'MAINTENANCE_PERIOD_MODAL_CONTENT' | translate: notice }}</p>
  </div>
}
